import { useMutation } from '@tanstack/react-query';

import { ActivityEndpoints } from '../../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../../lib/axios';

export function useCreateVccMutation() {
  return useMutation({
    mutationFn: async (vars: { activityId: number }) => {
      return await getAxios().post(ActivityEndpoints.paymentCard.createVcc(vars.activityId));
    }
  });
}
